import { render, staticRenderFns } from "./searchs.vue?vue&type=template&id=4f879aba&scoped=true&"
import script from "./searchs.vue?vue&type=script&lang=js&"
export * from "./searchs.vue?vue&type=script&lang=js&"
import style0 from "./searchs.vue?vue&type=style&index=0&id=4f879aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f879aba",
  null
  
)

export default component.exports